/**
 * ============================================================================
 * EXPERIMENT: Travel Rhythm Display (ab_travel_rhythm)
 *
 * Backend-driven AB test — variant decided server-side via API
 * `meta.experiment.travelRhythm`. No Amplitude experiment, no entry in
 * `feature-flags.json`: the variant is implicit — the feature renders only
 * when the API returns a rhythm value.
 *
 * PR: #TODO_AFTER_PR_CREATION_ab_travel_rhythm
 * Expected end date: 2026-07-22 (remove all AB_* files and BEGIN/END markers by then).
 *
 * Temporary code — will be REMOVED when the experiment concludes.
 * Find all experiment code: grep -rn "ab_travel_rhythm" src/
 * ============================================================================
 */
import { useCallback, useMemo, useState } from 'react';

import {
    isTravelRhythmModalDismissed,
    markTravelRhythmModalDismissed,
} from '../../../../resources/dossier/AB_travelRhythm';
import { DossierId, TravelRhythmValue } from '../../../../resources/dossier/types';

type UseTravelRhythmModalResult = {
    shouldDisplay: boolean;
    dismiss: () => void;
};

export function AB_useTravelRhythmModal(
    dossierId: DossierId,
    value: TravelRhythmValue | undefined,
): UseTravelRhythmModalResult {
    const initialDismissed = useMemo(
        () => isTravelRhythmModalDismissed(dossierId, window.localStorage),
        [dossierId],
    );
    const [dismissed, setDismissed] = useState(initialDismissed);

    const dismiss = useCallback(() => {
        markTravelRhythmModalDismissed(dossierId, window.localStorage);
        setDismissed(true);
    }, [dossierId]);

    const shouldDisplay = !dismissed && value !== undefined;

    return { shouldDisplay, dismiss };
}
